import type { JSX } from 'react';

interface SuccessCheckmarkProps {
  accentColor: string;
  size?: number;
}

export function SuccessCheckmark({ accentColor, size = 80 }: SuccessCheckmarkProps): JSX.Element {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
      <svg width={size} height={size} viewBox="0 0 80 80" fill="none" aria-hidden="true">
        <circle
          cx="40"
          cy="40"
          r="38"
          stroke={accentColor}
          strokeWidth="2.5"
          fill={`${accentColor}15`}
        />
        <path
          d="M24 40 L35 51 L56 30"
          stroke={accentColor}
          strokeWidth="3.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </svg>
    </div>
  );
}
